module.exports = __webpack_public_path__ + "static/Logo-75c9ad571579b06da7c21346d81d24a8.png";